import type { ReactNode } from 'react';

import { InputLabel } from '@/components/InputLabel';
import { Input } from '@/components/ui/input';

import { useImagePicker } from '../useImagePicker';

import { ImageTilePicker } from './ImageTilePicker';
import { ImageTilePreview } from './ImageTilePreview';

type Props = {
  id: string;
  label?: string;
  hint?: ReactNode;
  isRequired?: boolean;
  isInvalid: boolean;
  url?: string;
  isRemovable: boolean;
  className?: string;
  onChange: (value: File | '') => void;
};

export const ImageTile = (props: Props) => {
  const {
    id,
    label,
    hint,
    isRequired,
    isInvalid,
    url,
    isRemovable,
    className,
    onChange,
  } = props;

  const { previewUrl, openPicker, removeFile, inputProps } = useImagePicker({
    url,
    onChange,
  });

  return (
    <>
      {label && (
        <InputLabel
          htmlFor={id}
          label={label}
          isRequired={isRequired}
          hint={hint}
          isInvalid={isInvalid}
        />
      )}
      {previewUrl ? (
        <ImageTilePreview
          url={previewUrl}
          label={label}
          className={className}
          onRemove={isRemovable ? removeFile : undefined}
        />
      ) : (
        <ImageTilePicker
          className={className}
          isInvalid={isInvalid}
          onClick={openPicker}
        />
      )}
      <Input
        id={id}
        aria-label={label}
        {...inputProps}
      />
    </>
  );
};
